import React, { useState, useEffect } from "react";
import ReactSlidy from "react-slidy";
import "react-slidy/lib/styles.css";

const ArticleScreenSlider = ({ images }) => {
  const [slide, changeSlide] = useState(0);

  useEffect(() => {
    if (!images || !images.length) return;
    const updateSlider = () => {
      const nextSlide = slide + 1 === images.length ? 0 : slide + 1;
      changeSlide(nextSlide);
    };

    const interval = setInterval(updateSlider, 6000);
    return () => clearInterval(interval);
  }, [slide]);

  if (!images || !images.length) return null;

  if (images.length === 1)
    return (
      <div className="container-fluid p-0">
        <div
          alt="slider"
          className=" text-center header-image"
          style={{ backgroundImage: `url(${images[0]})` }}
        ></div>
      </div>
    );

  return (
    <div className="container-fluid p-0">
      <ReactSlidy slideSpeed={500} slide={slide}>
        {images.map((img) => (
          <div
            key={img}
            alt="slider"
            className=" text-center header-image"
            style={{ backgroundImage: `url(${img})` }}
          ></div>
        ))}
      </ReactSlidy>
    </div>
  );
};

export default ArticleScreenSlider;



// WEBPACK FOOTER //
// ./src/screens/MainPage/ArticleScreenSlider.js